import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Container from './Container'
import Section from './Section'
import styled, { css } from 'styled-components/macro'
import Logo from './Logo'
import QuestionLabel from '../containers/questions/QuestionLabel'
import { useAppContext } from '../../context/AppContext'
import { rem } from 'polished'
import { AnimatePresence } from 'framer-motion'
// import { useAnalytics } from 'use-analytics'
import Footer from './Footer'

const MasterPage = ({
  children,
  isBold,
  showProgress,
  showCaption,
  isResults,
  caption,
  heading,
}) => {
  // const { track, page } = useAnalytics()
  const {
    data,
    quiz: { answers, questionId, startTime, setStartTime },
  } = useAppContext()

  // const [hasTracked1, setHasTracked1] = useState(false)
  const [currentSelection, setCurrentSelection] = useState(null)

  const questionIndex = questionId - 1
  // useEffect(() => {
  //   track('page_load')
  // }, [track])

  useEffect(() => {
    // page()
    if (questionIndex === 0 && !startTime) setStartTime(new Date())
    //eslint-disable-next-line
  }, [questionId])

  useEffect(() => {
    const selection = answers[questionId - 1]
    let response
    if (data.length >= questionId - 1 && selection.length > 0) {
      const { answers: opts } = data[questionId - 1]
      if (opts.length >= selection[0]) {
        response = opts[selection[0]].text
      }
    }
    setCurrentSelection(response)
    //eslint-disable-next-line
  }, [answers, questionId])

  const multiplier = isResults ? 1 : questionId / (data.length + 1)

  return (
    <Section>
      <Container>
        <StyledLogo />
        <Content>
          <AnimatePresence exitBeforeEnter>
            <QuestionLabel
              text={heading}
              caption={caption}
              questionId={questionId}
              responseText={currentSelection}
              showCaption={showCaption}
            />
          </AnimatePresence>
          <Frame>
            {children}
            {showProgress && (
              <ProgressWrapper>
                <Progress width={Math.ceil(multiplier * 100) + '%'} />
              </ProgressWrapper>
            )}
          </Frame>
        </Content>
      </Container>
      <Footer />
    </Section>
  )
}

MasterPage.propTypes = {
  children: PropTypes.any,
  isBold: PropTypes.bool,
  showProgress: PropTypes.bool,
  showCaption: PropTypes.bool,
  isResults: PropTypes.bool,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  caption: PropTypes.string,
}

MasterPage.defaultProps = {
  isBold: false,
  showProgress: true,
  showCaption: true,
  isResults: false,
}

export default MasterPage

const StyledLogo = styled(Logo)`
  ${({ theme }) => css`
    margin: 13px auto 25px;
    ${theme.media.lg`
      margin: 32px auto 40px;
    `}
  `}
`

const Content = styled.div(
  ({ theme }) => css`
    margin-top: -1em;
    ${theme.media.xl`
        padding: 0;
      `};
    > a {
      min-width: ${rem(237)};

      ${theme.media.xl`
        min-width: ${rem(336)};
      `};
    }

    ${theme.media.lg`
    `};
  `,
)

const Frame = styled.div(
  ({ theme }) => css`
    max-width: 1046px;
    margin: 0 auto;
    padding: 0 20px;
    ${theme.media.lg`
      padding: 0 20px;
    `}
  `,
)
const ProgressWrapper = styled.div(
  ({ theme }) => css`
    background: ${theme.color.darkGray};
    width: 90%;
    margin: 0 auto;
    overflow: hidden;
    ${theme.media.lg`
      margin: 2em auto 1em;
    `}
  `,
)
const Progress = styled.div(
  ({ theme, width = '100%' }) => css`
    width: ${width};
    height: ${rem(6)};
    background: ${theme.color.answerBackground};
    transition: width 0.5s ease-in-out;
    ${theme.media.lg`
      height: ${rem(9)};
    `};
  `,
)
